import { render, staticRenderFns } from "./commonSearch.vue?vue&type=template&id=5713425a&scoped=true"
import script from "./commonSearch.vue?vue&type=script&lang=js"
export * from "./commonSearch.vue?vue&type=script&lang=js"
import style0 from "./commonSearch.vue?vue&type=style&index=0&id=5713425a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5713425a",
  null
  
)

export default component.exports